/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */

import { Record } from 'immutable'

const TaskSearchConditionState = Record({
  status: ['open'],
  title: '',
  room_ids: []
})

export { TaskSearchConditionState }
